'use strict';

const ConstructableContainer = require('../rlink-data-connector/storage/ConstructableContainer');

module.exports = function container (type, ...args) {
  return new ConstructableContainer(type, args);
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/container.js